module.exports = __webpack_public_path__ + "home.77cd5e488c8c069f1fd4.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/agencehoffman/Desktop/Workspace/catherinet/src/app/assets/images/home.jpg
// module id = ../../../../../src/app/assets/images/home.jpg
// module chunks = main